import { getQueryArgs } from '@/utils/url-utils'

export default {
    getPvId: function () {
        var spmCode;
        var pvId = 0;
        if(window.sohuSpm && typeof window.sohuSpm.getCodes === 'function') {
            spmCode = window.sohuSpm.getCodes();
            pvId = spmCode.e;
        }
        return pvId;
    },
    getSpmCode: function (url) {
        url = url || document.location.href
        return getQueryArgs(url).spm || ''
    },
    getPageSpm: function () {
        var spmAB
        if (window.sohuSpm && typeof window.sohuSpm.getCodes === 'function') {
            var spmCode = window.sohuSpm.getCodes();
            spmAB = {
                a: spmCode.a,
                b: spmCode.b,
            }
        }
        return spmAB
    },
    /**
     * @desc spm统计acode方法
     * @param {string} acode 统计acode码
     * @param {string} clkParam 自定义参数
     */
    sendAction: function(acode, clkParam) {
        if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
            window.sohuSpm.sendAction({
                acode: acode,
                clkParam: clkParam
            })
        }
    },
    /**
     * @description 手动给区块埋码，若不传c码，则是给所有区块手动进行一次埋码
     * @param {string} spmCCode 区块c码
     */
    domDidChange: function(spmCCode){
        if(!(typeof spmCCode === 'string' && spmCCode)){
            console.error('手动进行ev埋点上报时c码不存在，请修正，调用位置：')
            const error = new Error();
            const stack = error.stack.split('\n');
            console.log(stack[2].trim());
        }
        if(window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function'){
            window.sohuSpm.domDidChange({
                target: spmCCode
            })
        }
    },
    /**
     * @description 根据数据获取data-spm-content的值，用于上报
     * @param {{resourceType: number, authorId: string, id: string, pcm: string, type: string, etc: string}} data
     * @return {string} data-spm-content的值
     */
    getSpmContent(data){
        const _spmAttrArr = ['resourceType', 'authorId', 'id', 'pcm', 'type', 'etc']
        const _spmConArr = []
        for (let attr in _spmAttrArr) _spmConArr.push(data[_spmAttrArr[attr]] ? data[_spmAttrArr[attr]] : '')
        return _spmConArr.join('|')
    }
}